var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('PageTitle',{attrs:{"title":"Developed By","subtitle":"Bankole Esan (aka <a href='https://bankole2000.github.io/webpieces' target='_blank'>@CodingInNeon</a>)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }